export const bookingTimes = Array.from({ length: 16 }, (_, i) => {
  const h = 9 + Math.floor(i / 2);
  return `${String(h).padStart(2, "0")}:${i % 2 ? "30" : "00"}`;
}).filter((t) => !t.startsWith("12:"));
export function calendarDate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
export function bookingWindow(now = new Date()) {
  const today = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Phoenix",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
  const shift = (n) => {
    const d = new Date(`${today}T12:00:00Z`);
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  };
  return { min: shift(3), max: shift(60) };
}
export function validateBooking(data, now = new Date()) {
  const { min, max } = bookingWindow(now);
  const d = new Date(`${data.date}T12:00:00Z`);
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(data.date || "") ||
    Number.isNaN(d.getTime()) ||
    d.toISOString().slice(0, 10) !== data.date ||
    data.date < min ||
    data.date > max ||
    [0, 6].includes(d.getUTCDay()) ||
    !bookingTimes.includes(data.time)
  )
    return "Please choose an available weekday and time.";
  if (
    typeof data.name !== "string" ||
    data.name.trim().length < 2 ||
    data.name.length > 150 ||
    typeof data.email !== "string" ||
    data.email.length > 150 ||
    !/^\S+@[^\s@]+\.[^\s@]+$/.test(data.email)
  )
    return "Enter your name and a valid email.";
  return null;
}
